const PUJA_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "Pujas",
  url: "https://www.templedekho.com/pujas",
  hasPart: [
    {
      "@type": "WebPage",
      name: "Vivah Bandhan Sankalp",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Baba-Baidyanath-Dham&pujaNameKey=Gathbandhan-Puja%22",
    },
    {
      "@type": "WebPage",
      name: "Mahakal Raksha Naam Gotra Sankalp",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Mahakaleshwar-Jyotirlinga&pujaNameKey=Mahakal-Raksha-Naam-Gotra-Sankalp%22",
    },
    {
      "@type": "WebPage",
      name: "Karz Mukti Maha Havan (Debt Relief)",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Tarapith-Temple&pujaNameKey=Wrin-Mukti-Maha-Havan-Debt-Relief%22",
    },
    {
      "@type": "WebPage",
      name: "Navagraha Dosh Nivaran Pujan",
      url: "https://www.templedekho.com/templePujaInfo?templeNameKey=Navgrah-Shani-Temple-Ujjain&pujaNameKey=Navagraha-Dosh-Nivaran-Pujan%22",
    },
  ],
};

const PUJA_LIST_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.templedekho.com/#organization",
      name: "TempleDekho",
      url: "https://www.templedekho.com",
      logo: "https://www.templedekho.com/assets/images/logo.png",
      description:
        "TempleDekho offers online puja booking services at renowned temples across India with experienced priests.",
      areaServed: "IN",
      sameAs: [
        "https://www.facebook.com/templedekho",
        "https://www.instagram.com/templedekho",
        "https://twitter.com/templedekho",
      ],
    },
    {
      "@type": "WebPage",
      "@id": "https://www.templedekho.com/pujas/#webpage",
      url: "https://www.templedekho.com/pujas",
      name: "Online Puja Booking Services in India",
      description:
        "Book online pujas and religious rituals at famous temples in India. Receive puja photos, videos, and prasad.",
      isPartOf: {
        "@id": "https://www.templedekho.com/#organization",
      },
    },
    {
      "@type": "Service",
      "@id": "https://www.templedekho.com/pujas/#service",
      name: "Online Puja Booking",
      serviceType: "Hindu Religious Puja Services",
      description:
        "Online booking of pujas and rituals performed by experienced priests at temples across India.",
      provider: {
        "@id": "https://www.templedekho.com/#organization",
      },
      areaServed: {
        "@type": "Country",
        name: "India",
      },
      audience: {
        "@type": "Audience",
        audienceType: "Devotees",
      },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.templedekho.com/pujas/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.templedekho.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Pujas",
          item: "https://www.templedekho.com/pujas",
        },
      ],
    },
  ],
};

const TD_HOME_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://www.templedekho.com/pujas#webpage",
  url: "https://www.templedekho.com/pujas",
  name: "Book Personalized Pujas & Online Rituals | Temple Dekho",
  description:
    "Temple Dekho helps devotees book personalized pujas, rituals, and e-pujas across famous temples in India. Experience live darshans, chadhava, and prasad delivery with trusted priests and authentic traditions.",
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.templedekho.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Pujas",
        item: "https://www.templedekho.com/pujas",
      },
    ],
  },
  publisher: {
    "@type": "Organization",
    name: "Temple Dekho",
    logo: {
      "@type": "ImageObject",
      url: "https://www.templedekho.com/assets/logo.png",
    },
    url: "https://www.templedekho.com/",
    email: "support@templedekho.com",
    telephone: "+91-90733-00055",
    address: {
      "@type": "PostalAddress",
      streetAddress: "5th Floor Continental Chambers, 15A Hemanta Basu Sarani",
      addressLocality: "Kolkata",
      postalCode: "700001",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/templedekho",
      "https://www.instagram.com/templedekho",
      "https://www.twitter.com/templedekho",
    ],
  },
  mainEntity: {
    "@type": "ItemList",
    name: "Available Online Pujas",
    itemListElement: [
      {
        "@type": "Service",
        name: "Baglamukhi Jaap For Wealth & Legal Relief",
        serviceType: "Relief Puja",
        areaServed: "India",
        provider: { "@type": "Organization", name: "Temple Dekho" },
        offers: {
          "@type": "Offer",
          price: "1130",
          priceCurrency: "INR",
          description:
            "Resolve court cases, stop black magic, and gain prosperity with Baglamukhi Jaap at Baba Baidyanath Dham, Deoghar, Jharkhand.",
        },
      },
      {
        "@type": "Service",
        name: "Vivah Bandhan Sankalp For Happy Married Life",
        serviceType: "Marriage Puja",
        provider: { "@type": "Organization", name: "Temple Dekho" },
        offers: {
          "@type": "Offer",
          price: "1615",
          priceCurrency: "INR",
          description:
            "Attract love and build a happy married life through divine blessings.",
        },
        areaServed: "Baba Baidyanath Dham, Deoghar, Jharkhand",
      },
      {
        "@type": "Service",
        name: "Kaal Sarp Dosha Nivaran Sankalp",
        serviceType: "Dosh Nivaran Puja",
        provider: { "@type": "Organization", name: "Temple Dekho" },
        offers: {
          "@type": "Offer",
          price: "777",
          priceCurrency: "INR",
          description:
            "Freedom from Kaal Sarp Dosh and Pitru Dosh at Siddhavat Temple, Ujjain.",
        },
        areaServed: "Siddhavat Temple, Ujjain, Madhya Pradesh",
      },
      {
        "@type": "Service",
        name: "Rudrabhishek Puja",
        serviceType: "Health & Wellbeing Puja",
        provider: { "@type": "Organization", name: "Temple Dekho" },
        offers: {
          "@type": "Offer",
          price: "3535",
          priceCurrency: "INR",
          description:
            "Performed for good health and peace of mind at Baba Baidyanath Dham, Deoghar.",
        },
        areaServed: "Baba Baidyanath Dham, Deoghar, Jharkhand",
      },
      {
        "@type": "Service",
        name: "Navgraha Dosh Nivaran Puja",
        serviceType: "Astrological Dosh Nivaran Puja",
        provider: { "@type": "Organization", name: "Temple Dekho" },
        offers: {
          "@type": "Offer",
          price: "777",
          priceCurrency: "INR",
          description:
            "Neutralize malefic effects of planets at Mangalnath Temple, Ujjain.",
        },
        areaServed: "Mangalnath Temple, Ujjain, Madhya Pradesh",
      },
    ],
  },
  potentialAction: [
    {
      "@type": "SearchAction",
      target: "https://www.templedekho.com/search?query={search_term_string}",
      "query-input": "required name=search_term_string",
    },
    {
      "@type": "ReserveAction",
      target: "https://www.templedekho.com/pujas",
      name: "Book Online Puja",
    },
  ],
};

const TEMPLE_LIST_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.templedekho.com/#organization",
      name: "TempleDekho",
      url: "https://www.templedekho.com",
      logo: "https://www.templedekho.com/assets/images/logo.png",
      description:
        "TempleDekho helps devotees discover famous temples across India and book online pujas with experienced priests.",
      areaServed: "IN",
      sameAs: [
        "https://www.facebook.com/templedekho",
        "https://www.instagram.com/templedekho",
        "https://twitter.com/templedekho",
      ],
    },
    {
      "@type": "WebPage",
      "@id": "https://www.templedekho.com/temples/#webpage",
      url: "https://www.templedekho.com/temples",
      name: "Famous Temples in India",
      description:
        "Explore famous Hindu temples across India with details about location, history, significance, and available pujas.",
      isPartOf: {
        "@id": "https://www.templedekho.com/#organization",
      },
    },
    {
      "@type": "ItemList",
      "@id": "https://www.templedekho.com/temples/#itemlist",
      name: "List of Famous Temples in India",
      description:
        "A curated list of renowned temples across India available on TempleDekho.",
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      numberOfItems: 0,
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.templedekho.com/temples/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.templedekho.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Temples",
          item: "https://www.templedekho.com/temples",
        },
      ],
    },
  ],
};

const TEMPLE_CHADHAVA_LIST_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.templedekho.com/#organization",
      name: "TempleDekho",
      url: "https://www.templedekho.com",
      logo: "https://www.templedekho.com/assets/images/logo.png",
      description:
        "TempleDekho helps devotees discover temples across India and make online chadhava offerings and puja bookings with trained priests.",
      areaServed: "IN",
      sameAs: [
        "https://www.facebook.com/templedekho",
        "https://www.instagram.com/templedekho",
        "https://twitter.com/templedekho",
      ],
    },
    {
      "@type": "WebPage",
      "@id": "https://www.templedekho.com/chadhavaTemples/#webpage",
      url: "https://www.templedekho.com/chadhavaTemples",
      name: "Chadhava Temples – Offerings & Temple Discovery",
      description:
        "Explore temples across India where devotees can make chadhava offerings online or visit for traditional offerings.",
      isPartOf: {
        "@id": "https://www.templedekho.com/#organization",
      },
    },
    {
      "@type": "ItemList",
      "@id": "https://www.templedekho.com/chadhavaTemples/#itemlist",
      name: "List of Temples for Chadhava Offerings",
      description:
        "A curated list of temples across India where devotees can make chadhava offerings online or visit for temple offerings.",
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      numberOfItems: 0,
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.templedekho.com/chadhavaTemples/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.templedekho.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Chadhava Temples",
          item: "https://www.templedekho.com/chadhavaTemples",
        },
      ],
    },
  ],
};

export {
  PUJA_SCHEMA,
  PUJA_LIST_SCHEMA,
  TD_HOME_SCHEMA,
  TEMPLE_LIST_SCHEMA,
  TEMPLE_CHADHAVA_LIST_SCHEMA,
};
